export default __webpack_public_path__ + "static/media/w7.a4d6bbe4.png";